/* eslint-disable react/no-unknown-property */
import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { Modal, Form } from "react-bootstrap";
import { Button } from "reactstrap";

const AddAgent = ({ show, handleClose, formik, t, submitting, isEdit }) => {
  return (
    <Modal
      size="md"
      show={show}
      onHide={handleClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {isEdit ? t("Edit Agent") : t("Add Agent")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={formik.handleSubmit}>
          <div className="row">
            <div className="col-12">
              <Form.Group className="mb-3" controlId="agentName">
                <Form.Label>{t("Name")}</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                  placeholder=""
                />
                {formik.touched.name && formik.errors.name ? (
                  <div style={{ color: "red" }}>{formik.errors.name}</div>
                ) : null}
              </Form.Group>
            </div>
            <div className="col-12">
              <Form.Group className="mb-3" controlId="agentEmail">
                <Form.Label>{t("Email")}</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  placeholder=""
                />
                {formik.touched.email && formik.errors.email ? (
                  <div style={{ color: "red" }}>{formik.errors.email}</div>
                ) : null}
              </Form.Group>
            </div>
            <div className="col-12">
              <Form.Group className="mb-3" controlId="agentPhone">
                <Form.Label>{t("Phone")}</Form.Label>
                <Form.Control   
                  type="text"
                  name="phone_number"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.phone_number}
                  placeholder=""
                />
                {formik.touched.phone_number && formik.errors.phone_number ? (
                  <div style={{ color: "red" }}>{formik.errors.phone_number}</div>
                ) : null}
              </Form.Group>
            </div>
          </div>
          <div className="text-end">
            <Button
              disabled={submitting}
              type="submit"
              variant="primary"
              className="all-common-btn mx-1"
              style={{ marginLeft: 10 }}
            >
              {isEdit ? t("Update") : t("Submit")}
            </Button>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
};

AddAgent.propTypes = {
  t: PropTypes.any,
  show: PropTypes.bool,
  handleClose: PropTypes.func,
  formik: PropTypes.any,
  submitting: PropTypes.bool,
  isEdit: PropTypes.bool,
};

export default withRouter(withTranslation()(AddAgent));


